module.exports = __webpack_public_path__ + "img/control_icon.cdcce347.png";